import { WIDGET_TYPES } from '../constants.js';

const parseWidgetType = widgetType => {
  switch (widgetType) {
    case WIDGET_TYPES.SESSIONS:
      return 'session';
    case WIDGET_TYPES.AGENDA:
      return 'agenda';
    case WIDGET_TYPES.SCHEDULE:
      return 'agenda';
    case WIDGET_TYPES.ROOMS:
      // SB-9570: Rooms is in the agenda family and shares its field selection.
      return 'agenda';
    case WIDGET_TYPES.SPEAKERS:
      return 'speaker';
    case WIDGET_TYPES.SPEAKERS_GALLERY:
      return 'speaker';
    default:
      return null;
  }
};

/**
 * Get the visible fields selected by admin in the Sessionboard UI for a given widget type
 * @param {Object} groupedFields
 * @param {string} widgetType
 * @returns {Array}
 */
const getVisibleFieldIdsOfType = (groupedFields, widgetType) => {
  const parsedWidgetType = parseWidgetType(widgetType);
  const visibleFields = groupedFields?.[parsedWidgetType] || [];
  const userSelectedFields = visibleFields.map(field => field.internal_name).filter(field => field);
  return userSelectedFields;
};

/**
 * Get the visible fields selected by admin for a given widget type mapped by id
 * @param {Object} groupedFields
 * @param {string} widgetType
 * @returns {Object} Object indexed by internal_name
 */
const getVisibleFieldsOfTypeById = (groupedFields, widgetType) => {
  const parsedWidgetType = parseWidgetType(widgetType);
  const visibleFields = groupedFields?.[parsedWidgetType] || [];
  // Reduce the array to an object indexed by internal_name
  return visibleFields.reduce((acc, field) => {
    if (field.internal_name) {
      acc[field.internal_name] = field;
    }
    return acc;
  }, {});
};

export default getVisibleFieldIdsOfType;

export { getVisibleFieldsOfTypeById };
